import { DashboardLayout } from "@/components/dashboard/dashboard-layout";
import EmployeeList from "./EmployeeList";

export default function EmployeesPage() {
  return (
    <DashboardLayout activeTab="company-profile">
      <EmployeeList />
    </DashboardLayout>
  );
}
